import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { paths } from "../paths";
import Button from "../../../_components/ui/Button";
import "./_error-page.scss";

const REDIRECT_SECONDS = 5;

// Handles unmatched URLs (see the `path: "*"` route in ../index.jsx). Distinct
// from RouteErrorBoundary, which is the root errorElement for render-time
// throws and lazy-chunk load failures rather than a 404.
const ErrorPage = () => {
  const navigate = useNavigate();
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    if (secondsLeft <= 0) {
      navigate(paths.home, { replace: true });
      return;
    }

    const countdown = setInterval(() => {
      setSecondsLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(countdown);
  }, [secondsLeft, navigate]);

  return (
    <div className="error-page">
      <h1 className="error-page__title">404</h1>
      <p className="error-page__message">
        Oops! The page you are looking for does not exist.
      </p>
      <Button
        className="error-page__action"
        onClick={() => navigate(paths.home, { replace: true })}
        variant="contained"
        size="md"
      >
        Go to Home
      </Button>
    </div>
  );
};

export default ErrorPage;
